import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "./auth.service";

@Injectable({ providedIn: 'root' })
export class ChildAuthGuard implements CanActivateChild {
    allowedRoutesForNonAdmin = ['/unconfirmed', '/error'];
    constructor(private authService: AuthService, private router: Router) { }
    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        const isAdmin = this.authService.isAdmin;
        if (!isAdmin) {
            if (!this.allowedRoutesForNonAdmin.some(url => state.url.startsWith(url))) {
                this.router.navigate([this.allowedRoutesForNonAdmin[0]]); // Redirect to non admin home page
                return false;
            }
        }
        return true;
    }
}

